import React, { useRef, useEffect, useState } from "react";
import Fade from "@material-ui/core/Fade";
import { makeStyles, Tooltip } from "@material-ui/core";

const useStyles = makeStyles(() => ({
  tooltip: {
    fontSize: 12,
    padding: "4px 14px",
    minWidth: 54,
    minHeight: 24,
    borderRadius: 4,
    backgroundColor: "rgba(0, 0, 0, 0.7)",
    color: "#ffffff",
    margin: "3px 0",
  },
  arrow: {
    fontSize: 8,
    color: "rgba(0, 0, 0, 0.7)",
  },
}));

const OverflowTooltip = ({ text = "" }) => {
  const classes = useStyles();
  const [hoverStatus, setHoverStatus] = useState(false);
  const textElementRef: React.Ref<any> = useRef();

  const compareSize = () => {
    const compare =
      textElementRef.current.scrollWidth > textElementRef.current.clientWidth;

    setHoverStatus(compare);
  };

  useEffect(() => {
    compareSize();
    window.addEventListener("resize", compareSize);

    //remove resize listener on text change or on "componentWillUnmount"
    return () => {
      window.removeEventListener("resize", compareSize);
    };
  }, [text]);

  return (
    <Tooltip
      title={text}
      interactive
      disableHoverListener={!hoverStatus}
      placement="top"
      classes={{ tooltip: classes.tooltip, arrow: classes.arrow }}
      TransitionComponent={Fade}
      TransitionProps={{ timeout: 200 }}
      enterDelay={200}
      arrow
    >
      <span
        ref={textElementRef}
        style={{
          display: "block",
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
        }}
      >
        {text}
      </span>
    </Tooltip>
  );
};

export default OverflowTooltip;
